import storage from "./storage.js";
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace PersonalOfferStorageService
 */
var PersonalOfferStorageService = function () {
    "use strict";

    let STORAGE_KEY = storage.metadata.PERSONAL_OFFER;

    // ---------------------------------------------
    //
    //            Define public methods
    //
    // ---------------------------------------------
    var publicMethods = {
        clearPersonalOffer: function(){
            publicMethods.setPersonalOffer(null);
        },
        getPersonalOffer: function(){
            let personalOffer = storage.getItem(STORAGE_KEY);
            let tmpOffer;
            if (personalOffer){
                tmpOffer = personalOffer;
            }
            return tmpOffer;
        },
        setPersonalOffer: function(personalOffer){
            if (personalOffer == null || typeof (personalOffer) == 'undefined') {
                storage.removeItem(STORAGE_KEY);
            } else {
                storage.setItem(STORAGE_KEY, personalOffer);
            }
        },
        isPersonalOffer: function(){
            var personalOffer = publicMethods.getPersonalOffer();
            return personalOffer !== null && personalOffer !== undefined;
        }
    };

    return publicMethods;
}();

export default PersonalOfferStorageService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/personalOfferStorageService.js
// module id = 181
// module chunks = 0